import { Label } from "@/components/ui/label";

export function AttendanceListEmpty() {
  return (
    <div className='--ct-flex-1 --ct-w-full --ct-grid --ct-place-items-center'>
      <Label>
        Você não tem nenhum atendimento em andamento.
      </Label>
    </div>
  )
}
